
import { useEffect, useRef, useState } from 'react';

export default function LatelySection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative bg-white py-16 lg:py-20 px-8 md:px-12 lg:px-[8%] overflow-hidden"
    >
      <div
        className={`max-w-2xl lg:ml-[8%] transition-all duration-700 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-[13px] tracking-[0.12em] text-[#A39B92] font-normal mb-4">
          Últimamente…
        </p>
        <p className="text-[20px] lg:text-[22px] text-[#3A3A3A] leading-[1.7] font-light">
          Estoy intentando simplificar todo.
        </p>
        <p className="text-[20px] lg:text-[22px] text-[#3A3A3A] leading-[1.7] font-light">
          Menos cosas, pero mejores.
        </p>
      </div>
    </section>
  );
}
